import { getPromotions } from './GetPromotions';
import { getPromotionPayouts } from './GetPromotionPayouts';
import { createPromotion } from './CreatePromotion';
import { updatePromotion } from './UpdatePromotion';
import { uploadPayouts } from './UploadPayouts';
import { downloadPayoutReport } from './DownloadPayoutReport';
import { getProfessionalPromotionPayouts } from './GetProfessionalPromotionPayouts';

export const PromotionsApi = {
  getPromotions,
  getPromotionPayouts,
  createPromotion,
  updatePromotion,
  uploadPayouts,
  downloadPayoutReport,
  getProfessionalPromotionPayouts,
};
